import { render, staticRenderFns } from "./StockListing.vue?vue&type=template&id=3415b2cc&scoped=true&"
import script from "./StockListing.vue?vue&type=script&lang=js&"
export * from "./StockListing.vue?vue&type=script&lang=js&"
import style0 from "./StockListing.vue?vue&type=style&index=0&id=3415b2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415b2cc",
  null
  
)

export default component.exports